import React from "react";
import { Col } from "../Grid";

const PageNavbarSearchSidebar = ({ ...props }) => {
	return <Col md={3} className="searchbar-field" {...props} />;
};

PageNavbarSearchSidebar.propTypes = {
	...Col.propTypes,
};

export default PageNavbarSearchSidebar;
